module.exports = __webpack_public_path__ + "img/OMBRA_CUT.949cc23a.png";